/**
 * Recorrido del dashboard por widgets (components/tour). Los textos están en
 * `dashboardWidgets.tour.*` y salen en el idioma de avisos ($tn).
 */

export const WIDGETS_TOUR_ID = "dashboard-widgets";
/** Días que el recorrido queda a mano desde la primera vez que el usuario lo ve. */
export const WIDGETS_TOUR_DAYS = 3;

const visible = (selector) => () =>
  Array.from(document.querySelectorAll(selector)).find((el) => {
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }) || null;

/** Tirador de tamaño de un widget que entre entero en la pantalla (el de un widget muy alto queda fuera de vista). */
const resizeHandle = () => {
  const items = Array.from(document.querySelectorAll(".vue-grid-item:not(.vue-grid-placeholder)"));
  const fits = items.find((el) => el.getBoundingClientRect().height < window.innerHeight * 0.6) || items[0];
  return (fits && fits.querySelector(":scope > .vue-resizable-handle")) || null;
};

const k = (name) => `dashboardWidgets.tour.${name}`;

export const widgetsTour = {
  id: WIDGETS_TOUR_ID,
  steps: [
    { titleKey: k("welcomeTitle"), bodyKey: k("welcomeBody") },
    { target: '[data-tour="dw-add"]', titleKey: k("addTitle"), bodyKey: k("addBody"), advanceOn: "click", placement: "bottom" },
    { target: visible(".dwc__panel"), titleKey: k("catalogTitle"), bodyKey: k("catalogBody"), bodyMobileKey: k("catalogBodyMobile"), interactive: true },
    { target: visible(".dwc__foot .btn-primary"), titleKey: k("catalogDoneTitle"), bodyKey: k("catalogDoneBody"), advanceOn: "click", placement: "top" },
    { target: visible(".vue-grid-item .dw-head"), titleKey: k("moveTitle"), bodyKey: k("moveBody"), only: "desktop", placement: "bottom" },
    { target: resizeHandle, titleKey: k("resizeTitle"), bodyKey: k("resizeBody"), only: "desktop", placement: "left" },
    { target: '[data-tour="dw-reorder"]', titleKey: k("reorderTitle"), bodyKey: k("reorderBody"), only: "mobile" },
    { target: visible(".dw-menu .dw-btn"), titleKey: k("menuTitle"), bodyKey: k("menuBody"), placement: "left" },
    { target: '[data-tour="dw-preset-new"]', titleKey: k("presetsTitle"), bodyKey: k("presetsBody"), placement: "bottom" },
    { titleKey: k("endTitle"), bodyKey: k("endBody") },
  ],
};
